import { useHasPermission } from "@/hooks/useHasPermission";

export const useCanAccessUserManagerApp = () => useHasPermission("auth:user");

export const useCanAccessAdminPanel = () => useHasPermission("auth:superadmin");

export const useCanAccessUsersView = () => useHasPermission("auth:user:read");
export const useCanEditUserDetails = () => useHasPermission("auth:user:edit");
export const useCanDeleteUser = () => useHasPermission("auth:user:delete");
export const useCanCreateUser = () => useHasPermission("auth:user:create");

export const useCanAccessRolesView = () => useHasPermission("auth:role:read");

export const useCanCreateRole = () => useHasPermission("auth:role:create");
export const useCanEditRole = () => useHasPermission("auth:role:edit");
export const useCanDeleteRole = () => useHasPermission("auth:role:delete");

export const useCanRunAs = () => useHasPermission("auth:user:runas");

export const useCanViewUserActivity = () => useHasPermission("auth:user:activity");

export const useCanViewUserChanges = () => useHasPermission("auth:user:changes");

export const useCanEditProduct = () => useHasPermission("auth:product:edit");

export const useCanEditCompanySettings = () => useHasPermission("auth:company:edit");

export const useCanViewImports = () => useHasPermission("auth:userimports:read");

export const useCanViewSecurityLogs = () => useHasPermission("auth:securitylogs:read");

export const useCanEditDynamicRoles = () => useHasPermission("auth:superadmin");

export const useCanAccessAssistant = () => useHasPermission("auth:ai:chat");

export const useIsSupportOrSuperadmin = () => {
  const isSupport = useHasPermission("auth:support");
  const isSuperadmin = useHasPermission("auth:superadmin");
  return isSupport || isSuperadmin;
};

export const useCanSwitchCompany = () => useIsSupportOrSuperadmin();

export const useCanUseAi = () => useHasPermission("auth:ai:use");

export const useCanAccessTeams = () => useHasPermission("auth:team:read");

export const useCanEditTeam = () => {
  const hasEditPermission = useHasPermission("auth:team:edit");
  const isSuperadmin = useHasPermission("auth:superadmin");
  return hasEditPermission || isSuperadmin;
};

export const useCanAccessProvisioning = () => useHasPermission("auth:provisioning:manage");

export const useCanRequestAccess = () => useHasPermission("auth:accessrequest:request");

export const useCanViewAccessRequests = () => useHasPermission("auth:accessrequest:read");

export const useCanManageAccessRequests = () => useHasPermission("auth:accessrequest:manage");

export const useCanConfigureIntegration = () => {
  const hasPermission = useHasPermission("auth:integration:configure");
  const isSuperadmin = useHasPermission("auth:superadmin");
  return hasPermission || isSuperadmin;
};
